// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-2d12000f]{border:1px solid #e0e0e0!important}", ""]);
// Exports
module.exports = exports;
